import { createFileRoute } from '@tanstack/react-router'
import { redirect } from '@hooks'

const SettingsWebhook = redirect('/integration/webhook')

export const Route = createFileRoute('/settings/webhook/')({
  component: SettingsWebhook,
})
